module.exports = __webpack_public_path__ + "img/deliver-img-2-1.0590438b.png";